module.exports = __webpack_public_path__ + "static/img/3.2f44288.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/3/1/sp/3.png
// module id = 9+tu
// module chunks = 0